module.exports = __webpack_public_path__ + "img/wifi.19057711.svg";